/**
 * Replacement controller for mdChips directive.
 * Extends MdChipsCtrl by removing automatic input refocus after a chip is added.
 *
 * @type {ngController}
 * @see mdChipsDirectiveDecorator
 */
export class tmrMdChipsController {
  static ngType = 'controller'

  constructor(
    $scope,
    $attrs,
    $mdConstant,
    $log,
    $element,
    $timeout,
    $mdUtil,
    $exceptionHandler,
    $controller
  ) {
    'ngInject'
    let MdChipsCtrl = $controller('MdChipsCtrl', {
      $scope,
      $attrs,
      $mdConstant,
      $log,
      $element,
      $timeout,
      $mdUtil,
      $exceptionHandler,
    })

    MdChipsCtrl.focusInput = function () {
      this.selectChip(-1)
    }

    return MdChipsCtrl
  }
}
